import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AccredibleTooltipBase } from './tooltip-base';

@Component({
  selector: 'accredible-tooltip',
  styleUrls: ['./tooltip.component.scss', './tooltip-host.component.scss'],
  templateUrl: './tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('tooltipAnimation', [
      transition(':enter', [style({ opacity: 0 }), animate(100, style({ opacity: 1 }))]),
      transition(':leave', [animate(100, style({ opacity: 0 }))]),
    ]),
  ],
})
export class AccredibleTooltipComponent extends AccredibleTooltipBase {
  @HostBinding('id')
  @Input()
  tooltipId!: string;

  @HostBinding('class')
  get classes(): string {
    return this.customTemplate ? `accredible-tooltip-${this.tooltipDirection}` : '';
  }

  @HostBinding('@tooltipAnimation')
  animateTooltip(): void {
    // Do nothing
  }
}
